/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'

// Create Virtual Routes

const SwapLazyImport = createFileRoute('/swap')()
const StakingLazyImport = createFileRoute('/staking')()
const RewardAllocationLazyImport = createFileRoute('/reward-allocation')()
const PortfolioLazyImport = createFileRoute('/portfolio')()
const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const SwapLazyRoute = SwapLazyImport.update({
  path: '/swap',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/swap.lazy').then((d) => d.Route))

const StakingLazyRoute = StakingLazyImport.update({
  path: '/staking',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/staking.lazy').then((d) => d.Route))

const RewardAllocationLazyRoute = RewardAllocationLazyImport.update({
  path: '/reward-allocation',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/reward-allocation.lazy').then((d) => d.Route),
)

const PortfolioLazyRoute = PortfolioLazyImport.update({
  path: '/portfolio',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/portfolio.lazy').then((d) => d.Route))

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioLazyImport
      parentRoute: typeof rootRoute
    }
    '/reward-allocation': {
      id: '/reward-allocation'
      path: '/reward-allocation'
      fullPath: '/reward-allocation'
      preLoaderRoute: typeof RewardAllocationLazyImport
      parentRoute: typeof rootRoute
    }
    '/staking': {
      id: '/staking'
      path: '/staking'
      fullPath: '/staking'
      preLoaderRoute: typeof StakingLazyImport
      parentRoute: typeof rootRoute
    }
    '/swap': {
      id: '/swap'
      path: '/swap'
      fullPath: '/swap'
      preLoaderRoute: typeof SwapLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/portfolio': typeof PortfolioLazyRoute
  '/reward-allocation': typeof RewardAllocationLazyRoute
  '/staking': typeof StakingLazyRoute
  '/swap': typeof SwapLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/portfolio': typeof PortfolioLazyRoute
  '/reward-allocation': typeof RewardAllocationLazyRoute
  '/staking': typeof StakingLazyRoute
  '/swap': typeof SwapLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/portfolio': typeof PortfolioLazyRoute
  '/reward-allocation': typeof RewardAllocationLazyRoute
  '/staking': typeof StakingLazyRoute
  '/swap': typeof SwapLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/portfolio' | '/reward-allocation' | '/staking' | '/swap'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/portfolio' | '/reward-allocation' | '/staking' | '/swap'
  id:
    | '__root__'
    | '/'
    | '/portfolio'
    | '/reward-allocation'
    | '/staking'
    | '/swap'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  PortfolioLazyRoute: typeof PortfolioLazyRoute
  RewardAllocationLazyRoute: typeof RewardAllocationLazyRoute
  StakingLazyRoute: typeof StakingLazyRoute
  SwapLazyRoute: typeof SwapLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  PortfolioLazyRoute: PortfolioLazyRoute,
  RewardAllocationLazyRoute: RewardAllocationLazyRoute,
  StakingLazyRoute: StakingLazyRoute,
  SwapLazyRoute: SwapLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/portfolio",
        "/reward-allocation",
        "/staking",
        "/swap"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/portfolio": {
      "filePath": "portfolio.lazy.tsx"
    },
    "/reward-allocation": {
      "filePath": "reward-allocation.lazy.tsx"
    },
    "/staking": {
      "filePath": "staking.lazy.tsx"
    },
    "/swap": {
      "filePath": "swap.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
